import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import '../styles/global.css'
import '../styles/login.css'

const LoginButton = (props) => {
  const { loginWithRedirect } = useAuth0();

  return (
    <>
     <button className={props.styleOpt ? "tealBtn" : "whiteBtn"} onClick={() => loginWithRedirect()}>{props.text}</button>
    </>
  )
};

export default LoginButton;